export default "__VITE_ASSET__DD2ew6F$__"